/**
 * Learning Path model
 */
export class LearningPath {
  constructor(public value: string, public slug: string, public menuDescription?: string) {}
}
